__turbopack_context__.v({
  "accessHeader": "_9pnrGa_accessHeader",
  "accessTitle": "_9pnrGa_accessTitle",
  "bear": "_9pnrGa_bear",
  "bull": "_9pnrGa_bull",
  "card": "_9pnrGa_card",
  "cardHeader": "_9pnrGa_cardHeader",
  "descriptionCard": "_9pnrGa_descriptionCard",
  "descriptionTooltip": "_9pnrGa_descriptionTooltip",
  "divider": "_9pnrGa_divider",
  "fullDisplayWrapper": "_9pnrGa_fullDisplayWrapper",
  "getAccessWrapper": "_9pnrGa_getAccessWrapper",
  "iconWrapper": "_9pnrGa_iconWrapper",
  "icons": "_9pnrGa_icons",
  "mainContent": "_9pnrGa_mainContent",
  "mobileContent": "_9pnrGa_mobileContent",
  "preview": "_9pnrGa_preview",
  "rowWrapper": "_9pnrGa_rowWrapper",
  "title": "_9pnrGa_title",
});
